import { useState, useCallback, useMemo } from 'react';
import { useTracking } from 'react-tracking';
import loadable from '@loadable/component';

import { Button, Column } from '@simplywallst/ui-core';

import { useWatchlist } from '@/hooks/useWatchlist';

import useUser from '@/hooks/useUser';

import { BannerWrapper, Text, DismissButton } from './styled';

const WatchlistEducationModal = loadable(
  () => import('./WatchlistEducationModal')
);

const AutoAddCompanyToWatchlistBanner = () => {
  const { trackEvent } = useTracking();
  const [showModal, setShowModal] = useState(false);
  const { data: user, mutate: mutateUser } = useUser();
  const { data: watchlist, status: watchlistStatus } = useWatchlist();
  const [isBannerDismissed, setIsBannerDismissed] = useState(
    user.isWatchlistBannerDismissed
  );

  const handleBannerDismissed = useCallback(() => {
    setIsBannerDismissed(true);
    mutateUser({
      settings: {
        has_dismissed_wl_banner: true,
      },
    });
    trackEvent({
      type: 'track',
      subject: 'dismissAutoAddedCompanyBanner',
      action: 'click',
    });
  }, [mutateUser, trackEvent]);

  const hasAutoAddedCompany = useMemo(() => {
    if (watchlistStatus !== 'success' || typeof watchlist === 'undefined') {
      return false;
    }
    return watchlist.items.some((item) => item.autoAdded);
  }, [watchlist, watchlistStatus]);

  if (isBannerDismissed || !hasAutoAddedCompany) {
    return null;
  }

  return (
    <>
      <BannerWrapper
        noWrap
        alignItem="center"
        data-cy-id="watchlist-auto-add-banner"
      >
        <Text col={10} colMd={11}>
          <p>
            We've added your first recently viewed stocks for your convenience.{' '}
            <Button
              styleType="strongLink"
              display="inline-block"
              onClick={() => setShowModal(true)}
            >
              Learn More
            </Button>
          </p>
        </Text>
        <Column col={2} colMd={1}>
          <DismissButton styleType="louder" onClick={handleBannerDismissed}>
            Ok
          </DismissButton>
        </Column>
      </BannerWrapper>
      {showModal ? (
        <WatchlistEducationModal onClose={() => setShowModal(false)} />
      ) : null}
    </>
  );
};

export default AutoAddCompanyToWatchlistBanner;
